import { Stack, Typography } from '@mui/material';
import { PageAdminDto } from '../../services/dtos/page-admin.dto';
import './page-admin-ui.scss';

/**
 * Ui pour les pages admins
 * @constructor
 */
export default function PageAdminUi(props: Readonly<{ page: PageAdminDto }>) {
    //Retourne la vue
    return (
        <Stack className="stack-page-admin">
            <Typography variant="h2" sx={{ textAlign: 'center' }}>
                {props.page.title}
            </Typography>
            <Typography component="div" dangerouslySetInnerHTML={{ __html: props.page.content }}></Typography>
        </Stack>
    );
}
